import { useState } from "react";
import { forgotPassword } from "../../../core/services/keycloakApi";
import { getUserErrorMessage, logApiError } from "../../../core/utils/apiErrorUtils";

export const useForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleForgotPassword = async ({ email }) => {
    setLoading(true);
    setError("");

    try {
      await forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      logApiError("Forgot password", err);
      setError(getUserErrorMessage(err, "Unable to send reset email. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  return {
    handleForgotPassword,
    loading,
    error,
    success,
  };
};